import { CompanySearch, ExportCallLogsResponse } from '../call-log-service/call-log-service.types';
import { getRequest } from '../request/request.service';
import {
  AiPerformance,
  CallMetrics,
  CallMetricsChart,
  CallMetricsChartParams,
  CallbackQueue,
  DashboardFilters,
  Insights,
  SmsMetrics,
  SmsMetricsChart,
  SmsMetricsChartParams,
  TrendingTopicsExportParams,
} from './dashboard.service.types';

export const METRICS_URL = 'metrics';

export function getCallMetrics(params: DashboardFilters) {
  return getRequest<CallMetrics>(`${METRICS_URL}/calls`, { params });
}

export function getSmsMetrics(params: DashboardFilters) {
  return getRequest<SmsMetrics>(`${METRICS_URL}/text_conversations`, { params });
}

export function getInsights(params: DashboardFilters) {
  return getRequest<Insights>(`${METRICS_URL}/insights`, { params });
}

export function getAiPerformance(params: DashboardFilters) {
  return getRequest<AiPerformance>(`${METRICS_URL}/ai_performance`, { params });
}

export function getCallbackQueue(params: DashboardFilters) {
  return getRequest<CallbackQueue>(`${METRICS_URL}/callback_queue`, { params });
}

export function getMetricsChart(params: CallMetricsChartParams) {
  return getRequest<CallMetricsChart>(`${METRICS_URL}/chart`, { params });
}

export function getSmsMetricsChart(params: SmsMetricsChartParams) {
  return getRequest<SmsMetricsChart>(`${METRICS_URL}/sms_chart`, { params });
}

export function getTrendingTopicsCsvFile(params: TrendingTopicsExportParams) {
  return getRequest<ExportCallLogsResponse>(`${METRICS_URL}/export_trending_topics`, {
    headers: { Accept: 'text/csv' },
    responseType: 'text',
    params,
  });
}

export function getCompanySearch(params: CompanySearch) {
  return getRequest<string[]>(`/companies/company_search`, { params });
}